import { OUTPUT_TYPE_COMMAND_MAP } from '../config/panelConfig/outputTypes';
import { PURPOSE_TO_PANEL_TYPE_MAP } from '../config/panelConfig/panelHierarchy';

/**
 * getPanelMenuItems - Panel tipine göre dinamik menü öğeleri oluşturur
 */
export function getPanelMenuItems(panelTypeId, panelTypes, outputTypes, outputCategories) {
  const panelType = panelTypes[panelTypeId];
  if (!panelType) return { outputGroups: [], panelOutputs: [] };

  const outputGroups = {};
  const panelOutputs = [];

  panelType.defaultOutputs.forEach(outputId => {
    const ot = outputTypes[outputId];
    if (!ot) return;

    if (ot.categoryId === 'PANEL') {
      panelOutputs.push(ot);
    } else {
      const cat = outputCategories[ot.categoryId];
      if (!outputGroups[ot.categoryId]) {
        outputGroups[ot.categoryId] = {
          category: cat,
          items: [],
        };
      }
      outputGroups[ot.categoryId].items.push(ot);
    }
  });

  const sortedGroups = Object.values(outputGroups).sort(
    (a, b) => a.category.order - b.category.order
  );

  return { outputGroups: sortedGroups, panelOutputs };
}

/**
 * mapOutputTypeToCommand - Çıkış tipini COMMANDS eşlemesine dönüştürür
 */
export function mapOutputTypeToCommand(outputTypeId) {
  return OUTPUT_TYPE_COMMAND_MAP[outputTypeId] || null;
}

/**
 * resolvePanelTypeId - kullanimAmac / code / label değerinden panelTypeId çözer
 * Önce doğrudan panelTypes key'i kontrol eder, sonra PURPOSE_TO_PANEL_TYPE_MAP'e bakar
 * @param {string} value - kullanimAmac, panel code veya label
 * @param {object} panelTypes - Redux'tan panel tipleri (opsiyonel)
 * @returns {string} panelTypeId
 */
export function resolvePanelTypeId(value, panelTypes) {
  if (!value) return 'MESKEN';

  // 1. Doğrudan panelTypes key'i mi?
  if (panelTypes && panelTypes[value]) {
    return value;
  }

  // 2. Sabit eşleme tablosunda var mı?
  if (PURPOSE_TO_PANEL_TYPE_MAP[value]) {
    return PURPOSE_TO_PANEL_TYPE_MAP[value];
  }

  // 3. panelTypes'ta label eşleşmesi ara
  if (panelTypes) {
    const match = Object.values(panelTypes).find(
      pt => pt.label === value || pt.code === value
    );
    if (match) return match.id;
  }

  return 'MESKEN';
}
